import * as React from "react";
import { forwardRef } from "react";
const SvgSendRequestSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", overflow: "visible", style: {
  display: "block"
}, width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "SendRequest" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M1.1725 12.25L13.4167 7L1.1725 1.75L1.16667 5.83333L9.91667 7L1.16667 8.16667L1.1725 12.25Z", fill: "white" })));
const ForwardRef = forwardRef(SvgSendRequestSmall);
export { ForwardRef as ReactComponent };
